import { render, staticRenderFns } from "./author_select.vue?vue&type=template&id=6dda7b8f"
import script from "./author_select.vue?vue&type=script&lang=js"
export * from "./author_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports